<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
        type="email"
        class="form-control"
        :id="inputId"
        :disabled="disabled"
        v-model="inputValue"
        @blur="checkEmail"
    />
    <div v-if="emailIsntCorrect" class="help-block error-text">
      Неверный формат электронной почты
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'OrganizationEmailInput',

  components: { Hint },

  data: function() {
    return {
      emailIsntCorrect: false
    }
  },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationInputMixin,
    organizationSectionMixin
  ],

  props: {
    inputLabel: {
      default: 'Адрес электронной почты'
    },

    inputName: {
      default: 'email'
    },

    inputHint: {
      default: undefined
    }
  },

  computed: {
    inputId () {
      return 'form-organization-email'
    }

  },
  methods: {
    checkEmail() {
      this.emailIsntCorrect = !!(this.inputValue !== null && this.inputValue.length > 0 && !/^[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(this.inputValue))
    }
  }
}
</script>
